import React, { Component, useEffect } from "react";
import * as stdActions from "../../redux/actions/stdAction";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar";
import { setLanguage } from "redux-i18n";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import * as attachmentsActions from "../../redux/actions/attachmentsAction";
import AttachmentsComponent from "../../components/Attachments";
import { initialPagination } from "../../App.config";
import { useLocation } from "react-router-dom";
import history from "../../utilities/history";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const Attachments = (props, context) => {
  const query = useQuery();
  const stdReducer = useSelector((state) => state.stdReducer);
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);
  const i18nReducer = useSelector((state) => state.i18nState);
  const attachmentsReducer = useSelector((state) => state.attachmentsReducer);

  const dispatch = useDispatch();
  let stdAction = bindActionCreators(stdActions, dispatch);
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonAction = bindActionCreators(commonActions, dispatch);
  const attachmentsAction = bindActionCreators(attachmentsActions, dispatch);

  const einParam = query.get("ein");
  const formType = "std";

  //Get query param and call api or redirect
  useEffect(() => {
    if (!einParam) {
      history.goBack();
    }

    attachmentsAction.getAttachments(einParam, null, profileReducer, {
      pageNo: attachmentsReducer.currentPage,
      pageSize: attachmentsReducer.pageSize,
      totalRows: attachmentsReducer.totalRows,
    });
    attachmentsAction.setIsCustomAttachment(null);

  }, []);

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };
  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const downloadAllAttachments = (ein, isCustomAttachment) => {
    attachmentsAction.downloadAllAttachments(ein, isCustomAttachment, profileReducer);
  };

  const onChange = (page) => {
    attachmentsAction.setCurrentPage(page.value);
    attachmentsAction.getAttachments(
      einParam,
      attachmentsReducer.isCustomAttachment,
      profileReducer,
      {
        pageNo: page.value,
        pageSize: attachmentsReducer.pageSize,
        totalRows: attachmentsReducer.totalRows,
      }
    );
  };

  const customAttachment = (ein) => {
    attachmentsAction.getAttachments(
      ein.length ? ein : null,
      true,
      profileReducer,
      initialPagination
    );
    attachmentsAction.setIsCustomAttachment(true);
    attachmentsAction.setCurrentPage(initialPagination.pageNo);
    attachmentsAction.setPageSize(initialPagination.pageSize);
  };

  const formAttachment = (ein) => {
    attachmentsAction.getAttachments(
      ein.length ? ein : null,
      false,
      profileReducer,
      initialPagination
    );
    attachmentsAction.setIsCustomAttachment(false);
    attachmentsAction.setCurrentPage(initialPagination.pageNo);
    attachmentsAction.setPageSize(initialPagination.pageSize);
  };

  const otherAttachment = (ein) => {
    attachmentsAction.getAttachments(
      ein.length ? ein : null,
      null,
      profileReducer,
      initialPagination
    );
    attachmentsAction.setIsCustomAttachment(null);
    attachmentsAction.setCurrentPage(initialPagination.pageNo);
    attachmentsAction.setPageSize(initialPagination.pageSize);
  };

  const onPageSizeChange = (pageSize, ein) => {
    attachmentsAction.getAttachments(
      ein.length ? ein : null,
      attachmentsReducer.isCustomAttachment,
      profileReducer,
      {
        pageNo: initialPagination.pageNo,
        pageSize: pageSize,
        totalRows: attachmentsReducer.totalRows,
      }
    );
    attachmentsAction.setCurrentPage(initialPagination.pageNo);
    attachmentsAction.setPageSize(pageSize);
    attachmentsAction.setIsCustomAttachment(
      attachmentsReducer.isCustomAttachment
    );
  };
  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}
      <div className="Content-Panel">
        <ShowForPermission module={PERMISSON_MODULES.DOCUMENTS_PAGE} permission={PERMISSION_TYPE.VIEW}>
          <AttachmentsComponent
            onChange={(props) => {
              onChange(props);
            }}
            i18nReducer={i18nReducer}
            context={context}
            customAttachment={customAttachment}
            formAttachment={formAttachment}
            otherAttachment={otherAttachment}
            onPageSizeChange={onPageSizeChange}
            isCustomAttachment={attachmentsReducer.isCustomAttachment}
            attachmentData={attachmentsReducer.attachments}
            currentPage={attachmentsReducer.currentPage}
            pageSize={attachmentsReducer.pageSize}
            totalRows={attachmentsReducer.totalRows}
            downloadAllAttachments={downloadAllAttachments}
            ein={einParam}
            formType={formType}
          />
        </ShowForPermission>
      </div>
    </>
  );
};

Attachments.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Attachments;
